/***********************
 * NODE HUM CHART
 * (+ IMPORT PDF/XLSX)
 ************************/

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Col, Row } from "reactstrap"
import { Link } from "react-router-dom"

//Translation
import { withTranslation } from "react-i18next"
import NodeChart from "components/Charts/NodeChart"

const NodeChartHumidity = props => {
  const chartId = "node-hum-chart"
  const [humData, setHumData] = useState(["", 0])

  // Loading state
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (props.showLoading != undefined) setIsLoading(props.showLoading)
  }, [props.showLoading])

  useEffect(() => {
    if (props.data != undefined) {
      let filterEmpty = props.data.filter(f => f[1] != 0)
      setHumData(filterEmpty)
    }
  }, [props.data])

  return (
    <div>
      {isLoading ? (
        <Row>
          <Col xs="12">
            <div className="text-center my-3">
              <Link to="#" className="text-primary">
                <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
                {props.t("Loading")}
              </Link>
            </div>
          </Col>
        </Row>
      ) : (
        <NodeChart
          chartId={chartId}
          data={humData}
          dataType={"humidity"}
        ></NodeChart>
      )}
    </div>
  )
}

NodeChartHumidity.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
  showLoading: PropTypes.bool,
}

export default withTranslation()(NodeChartHumidity)
